import { Type } from "../Type";
export function object(properties, name) {
    return new IslyObject(properties ?? {}, name);
}
export class IslyObject extends Type {
    properties;
    baseType;
    class = "object";
    constructor(properties, name, baseType) {
        super(() => name ??
            (this.baseType ? `${this.baseType.name} & ` : "") +
                `{${globalThis.Object.entries(this.properties)
                    .map(([property, type]) => `${property}: ${type.name}`)
                    .join(", ")}}`);
        this.properties = properties;
        this.baseType = baseType;
    }
    extend(properties, name) {
        return new IslyObject(properties, name, this);
    }
    omit(omits, name) {
        return new IslyObject(globalThis.Object.fromEntries(globalThis.Object.entries(this.properties).filter(([key]) => !omits.includes(key))), name ?? `Omit<${this.name}, ${omits.map(key => `"${String(key)}"`).join(" | ")}>`, this.baseType?.omit(omits));
    }
    pick(picks, name) {
        return new IslyObject(globalThis.Object.fromEntries(globalThis.Object.entries(this.properties).filter(([key]) => picks.includes(key))), name ?? `Pick<${this.name}, ${picks.map(key => `"${String(key)}"`).join(" | ")}>`, this.baseType?.pick(picks));
    }
    is = (value) => !!(value &&
        (this.baseType == undefined || this.baseType.is(value)) &&
        typeof value == "object" &&
        !globalThis.Array.isArray(value) &&
        globalThis.Object.entries(this.properties).every(([property, type]) => type.is(value[property])));
    createFlaw(value) {
        return {
            flaws: [
                this.baseType ? this.baseType.flaw(value)?.flaws ?? [] : [],
                globalThis.Object.entries(this.properties)
                    .map(([property, type]) => [property, type.flaw(value?.[property])])
                    .map(([property, flaw]) => (flaw?.isFlaw ?? true) && { property, ...flaw })
                    .filter(flaw => flaw),
            ]
                .flat()
                .filter(flaw => flaw?.isFlaw ?? true),
        };
    }
    getValue(value) {
        const result = this.baseType ? this.baseType.getValue(value) : {};
        if (result)
            for (const [key, type] of globalThis.Object.entries(this.properties))
                if (key in value)
                    result[key] = type.get(value[key]);
        return result;
    }
    getProperties() {
        return { ...this.baseType?.getProperties(), ...this.properties };
    }
}
//# sourceMappingURL=index.js.map